import CheckBox from "@/components/atoms/CheckBox/CheckBox";
import { PINNED_ASSET_SLUG } from "@/config/game";
import { useScrollLock } from "@/hooks/useScrollLock";
import { SKIP_MARK_AS_PLANNED_MODAL } from "@/settings";
import { Trans, useTranslation } from "@repo/shared/i18n";
import { useState } from "react";

import { BaseEvoPopup } from "./BaseEvoPopup";

interface MarkAsPlannedPopupProps {
  onClose: () => void;
  onConfirm: () => void;
}

export const MarkAsPlannedPopup = ({
  onClose,
  onConfirm,
}: MarkAsPlannedPopupProps) => {
  const { t } = useTranslation(["evolutions", "common"]);
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);
  useScrollLock(true);

  const handleConfirm = () => {
    if (doNotShowAgain) {
      localStorage.setItem(SKIP_MARK_AS_PLANNED_MODAL, "true");
    }
    onConfirm();
  };

  return (
    <BaseEvoPopup
      posLabel={t("common:confirm")}
      onPositive={handleConfirm}
      handleOnClose={onClose}
      title={t("popups.markPlanned.title")}
      imageUrl={
        import.meta.env.VITE_APP_ASSETS_BASE_URL +
        `/${PINNED_ASSET_SLUG}/evolutions-hub/my-evolutions/as-planned.png`
      }
    >
      <>
        <p>
          <Trans
            ns="evolutions"
            i18nKey="popups.markPlanned.body"
            components={{ i: <span className="italic" /> }}
          />
        </p>
        <div className="flex flex-col gap-y-4">
          <label className="flex items-center gap-2 cursor-pointer select-none text-sm text-foreground-body">
            <CheckBox
              checked={doNotShowAgain}
              onClick={() => setDoNotShowAgain((prev) => !prev)}
            />
            <span>{t("popups.doNotShowAgain")}</span>
          </label>
        </div>
      </>
    </BaseEvoPopup>
  );
};
